import axios from "axios";
import { BASE_URL } from "../config";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("authentication/token") ||
    localStorage.getItem("auth_token") ||
    localStorage.getItem("token") ||
    "";

  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const uploadMemberDeactivationBatch = (formData) =>
  axios.post(`${BASE_URL}/members/batch-deactivation/upload`, formData, {
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });

export const getMemberDeactivationBatchUploadHistory = (params) =>
  axios.get(`${BASE_URL}/members/batch-deactivation/uploads`, {
    params,
    headers: getAuthHeaders(),
  });

export const getMemberDeactivationBatchProcessedRows = (uploadId, params) =>
  axios.get(`${BASE_URL}/members/batch-deactivation/processed/${uploadId}`, {
    params,
    headers: getAuthHeaders(),
  });

export const exportMemberDeactivationBatchProcessedRows = (uploadId, params) =>
  axios.post(
    `${BASE_URL}/members/batch-deactivation/processed-export/${uploadId}`,
    {},
    {
      params,
      headers: getAuthHeaders(),
      responseType: "blob",
    }
  );

export const refreshMemberDeactivationBatchUploadSignedUrl = (uploadId) =>
  axios.post(
    `${BASE_URL}/members/batch-deactivation/refresh-url`,
    { upload_id: uploadId },
    { headers: getAuthHeaders() }
  );
